var pickerSlider = {
slidesToShow: 4,
    infinite: false,
    prevArrow: "<button type='button' class='slick-prev icon-chevron-left'></button>",
    nextArrow: "<button type='button' class='slick-next icon-chevron-right'></button>",
    responsive: [
    {
        breakpoint: 960,
        settings: {
            slidesToShow: 3,
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
        }
    }
]
};

$(".picker-slider").slick(pickerSlider);

var imgWidth = $(".picker-slider").find(".img").width();
var imgHeight = $(".picker-slider").find(".img").height();

/*$(".picker-slider").find(".detail").css({"width":imgWidth,"height":imgHeight});*/